import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { LayoutDashboard, CircleDollarSign, Truck, FileText, Compass, Sparkles } from "lucide-react";
import FiltersBar from "@/components/FiltersBar";

const NAV = [
  { to: "/", label: "Genel Bakış", icon: LayoutDashboard, testid: "nav-overview" },
  { to: "/maliyetler", label: "Nakliye Maliyetleri", icon: CircleDollarSign, testid: "nav-costs" },
  { to: "/nakliyeci-performansi", label: "Nakliyeci Performansı", icon: Truck, testid: "nav-carrier" },
  { to: "/ai-asistan", label: "AI Asistan", icon: Sparkles, testid: "nav-ai-assistant" },
  { to: "/raporlar", label: "Raporlar", icon: FileText, testid: "nav-reports" },
];

export default function DashboardLayout() {
  const loc = useLocation();
  const hideFilters = loc.pathname === "/ai-asistan";
  return (
    <div className="min-h-screen bg-[#F4F5F7]">
      {/* Sidebar */}
      <aside
        data-testid="sidebar"
        className="w-64 fixed left-0 top-0 h-screen bg-white border-r border-slate-200 z-30 flex flex-col"
      >
        <div className="h-16 flex items-center gap-3 px-5 border-b border-slate-200">
          <div className="w-9 h-9 rounded-md bg-[#0070F2] flex items-center justify-center shadow-sm">
            <Compass className="w-5 h-5 text-white" strokeWidth={2.2} />
          </div>
          <div>
            <div className="font-display text-[15px] font-semibold text-slate-900 leading-tight">SAP TM</div>
            <div className="text-[11px] uppercase tracking-[0.08em] text-slate-500 font-semibold">Analytics</div>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={n.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-[#E5F0FA] text-[#0054E3]"
                    : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                }`
              }
            >
              <n.icon className="w-[18px] h-[18px]" strokeWidth={2} />
              <span>{n.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-slate-200">
          <div className="rounded-md bg-slate-50 border border-slate-200 p-3">
            <div className="text-[11px] uppercase tracking-[0.08em] text-slate-500 font-semibold">Sürüm</div>
            <div className="text-xs text-slate-600 mt-1">v1.0 · Demo Veri</div>
          </div>
        </div>
      </aside>

      {/* Main */}
      <main className="ml-64 min-h-screen">
        <header className="h-16 sticky top-0 z-20 bg-white/85 backdrop-blur border-b border-slate-200 flex items-center px-6 lg:px-8">
          <div>
            <div className="text-[11px] uppercase tracking-[0.08em] text-slate-500 font-semibold">SAP TM</div>
            <h1 data-testid="page-title" className="font-display text-lg font-semibold text-slate-900 -mt-0.5">
              Taşıma Yönetimi Analiz Merkezi
            </h1>
          </div>
          <div className="ml-auto flex items-center gap-2 text-xs text-slate-500">
            <span className="inline-block w-2 h-2 rounded-full bg-emerald-500 pulse-dot" />
            <span>Canlı Demo</span>
          </div>
        </header>
        <div className="px-6 lg:px-8 py-6 space-y-6">
          {!hideFilters && <FiltersBar />}
          <Outlet />
        </div>
      </main>
    </div>
  );
}
